import Snapshots from "data/firestore/snapshots";
import SupabaseDocument from "data/supabase/document";
import Logger from "utils/logger";

// Supabase-backed snapshots. Reuses every computation method on the Firestore
// Snapshots class (total, methodsBreakdown, methodsOverTime, timeline, monthData,
// yearHasData, ...) -- those are pure over `this.raw` -- and only swaps the source:
// one row per month from the public.snapshots table (kept in sync by the DB trigger)
// instead of the single Firestore doc.
//
// The read is memoized by uid via SupabaseDocument.query, so the several
// `new User(uid).load(true)` calls a progress page fires (one per chart) collapse to
// a single fetch, and any session write resets the cache so the next read is fresh.
export default class SupabaseSnapshots extends Snapshots {
  async fetch() {
    try {
      const rows = await SupabaseDocument.query(
        "snapshots",
        (q) => q.eq("uid", this.id),
        `snapshots ${this.id}`
      );
      const data = {};
      for (const r of rows) {
        // month is a "YYYY-MM-01" date string, matching the Firestore raw keys.
        data[r.month] = {
          days: r.days,
          duration: r.duration_ms, // Snapshot uses `duration` (ms); column is duration_ms
          sessions: r.sessions,
          methods: r.methods || {},
        };
      }
      this.setRaw(data);
    } catch (error) {
      Logger.error("Error fetching snapshots from Supabase:", error);
      this.resetWith({});
    }
  }
}
